import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { ButtonLoader } from '../../components'
import { fetchFoundStockQueueTotal } from '../../services/foundStockServices'
import { foundStockQueryKeys } from '../FoundStock/foundStockQueryKeys'
import { FOUND_STOCK } from '../../navigation/constants'

// Spec §2.1: the hub shows how many declaration groups are unsettled.
export const FoundStockHubButton = () => {
  const history = useHistory()
  const { warehouse_id } = useParams()
  const { i18n } = useTranslation()
  const { data, error } = useQuery(foundStockQueryKeys.queueTotal(warehouse_id), () => fetchFoundStockQueueTotal(warehouse_id), {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false, // a 401 here is the common case for a user without the transfer grant
  })
  // Locations is gated on a different grant than found stock, so a Pundit 401 means the page behind
  // this button is a "no tienes acceso" dead end. Don't offer it.
  if (error?.response?.status === 401) return null
  const total = data?.total ?? 0
  return (
    <span>
      <ButtonLoader className="whitespace-nowrap" type="secondary" onClick={() => history.push(FOUND_STOCK.replace(':warehouse_id', warehouse_id))}>
        {i18n.t('list_locations.found_stock_button')}
        {total > 0 && (
          <span
            className="ml-2 inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-semibold bg-indigo-600 text-white"
            title={i18n.t('list_locations.found_stock_pending', { count: total })}
            data-testid="found-stock-badge"
          >
            {total}
          </span>
        )}
      </ButtonLoader>
    </span>
  )
}
